import { useState } from "react";

export const usePagination = () => {
  const [state, setState] = useState({
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
  });

//   const setCurrentPage = (page) => {
//     console.log("current page:", page)
//     setState(prev => ({ ...prev, currentPage: page }));
//   };

  const setCurrentPage = (pageOrUpdater) => {
  setState(prev => ({
    ...prev,
    currentPage:
      typeof pageOrUpdater === "function"
        ? pageOrUpdater(prev.currentPage)
        : pageOrUpdater,
  }));
};
  
  const setTotalPages = (pages) => {
    // console.log("setting total pages:", pages)
    setState(prev => ({...prev, totalPages: pages}))
  }

  const setToatalItems = (itemsCount) => {
    setState(prev => ({...prev, totalItems: itemsCount}))
  }

  return { ...state, setCurrentPage, setTotalPages, setToatalItems, setState };
};